import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'

function Footer() {
    return (
        <footer className="hidden-print footer mt-auto py-3" style={{ backgroundColor: '#f8f9fa' }}>
            <Container>
                <Row>
                    <Col className='text-center text-black-50'>
                        <span>StartBlue App - {new Date().getFullYear()}</span>
                    </Col>
                </Row>
                <Row>
                    <Col className='text-center text-black-50'>
                        <span>Made with <span style={{ color: '#007bff' }}>💙</span> by 
                        <a href="https://github.com/solosoyfranco" target="_blank" rel="noopener noreferrer" style={{ color: '#007bff', textDecoration: 'none' }}> Franco</a></span>
                    </Col>
                </Row>
                <Row>
                    <Col className='text-center'>
                        <a href="https://github.com/solosoyfranco/StartBlue-App/releases" target="_blank" rel="noopener noreferrer" style={{ color: '#007bff', textDecoration: 'none' }}>
                        Latest Updates
                        </a>
                    </Col>
                </Row>
                <Row>
                    <Col className='text-center'>
                    <LinkContainer to="/terms-and-conditions">
                        <span><a href="/terms-and-conditions" style={{ color: '#007bff', textDecoration: 'none' }}>
                        Terms and Conditions
                        </a></span>
                    </LinkContainer>
                    </Col>
                </Row>
            </Container>
        </footer>
    )
}

export default Footer
